import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SITroubleshootMechanical = () => {
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Troubleshooting</Breadcrumb.Item>
							<Breadcrumb.Item active>Mechanical Troubleshooting</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Mechanical Troubleshooting" className="mb-3 troubleshooting-element">
								<Tab eventKey="Mechanical Troubleshooting" title="Mechanical Troubleshooting">
									<h2>MECHANICAL TROUBLESHOOTING</h2>

									<p>Perhaps the most valuable but difficult-to-learn skill any mechanical repair person must have is the ability to troubleshoot a system. Troubleshooting, however, is a skill that can be learned like any other. Troubleshooters must be able to determine the cause or causes of a problem simply by examining its effects. Rarely does the source of a problem directly present itself for all to see. Cause/effect relationships are often complex, even for seemingly simple system. Typically, a misbehaving system is still functioning to some degree and may be stimulated and adjusted by the troubleshooter utilizing the proper diagnostic procedures.</p>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SITroubleshootMechanical;
